module.exports = __webpack_public_path__ + "static/media/undraw_programming_2svr.592e243b.png";